import { Box, Divider } from '@hopskipdrive/react-components';
import { colorTokens, variables } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

export const FormRow = styled.div`
  display: flex;
  gap: 36px;
  align-items: center;
  width: 100%;

  ${variables.mediaQuery.lessThan('desktop')`
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  `}
`;

export const FormField = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
  flex: 1;
  min-width: 0;

  label {
    width: 101px;
    min-width: 101px;
    flex-shrink: 0;
  }

  .MuiFormControl-root,
  .MuiAutocomplete-root {
    flex: 1;
    min-width: 150px;
  }

  .MuiOutlinedInput-root {
    width: 100%;
  }

  .MuiFormHelperText-root {
    width: 100%;
  }

  .MuiAutocomplete-inputRoot .MuiAutocomplete-input {
    min-width: 16px;
  }

  > .MuiBox-root {
    flex: 1;
    min-width: 0;
  }

  ${variables.mediaQuery.lessThan('desktop')`
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    width: 100%;

    label {
      width: auto;
      min-width: auto;
    }

    .MuiFormControl-root,
    .MuiAutocomplete-root {
      width: 100%;
      min-width: auto;
    }

    > .MuiBox-root {
      width: 100%;
    }
  `}
`;

export const HalfFormField = styled(FormField)`
  flex: none;
  width: calc(50% - 18px);

  ${variables.mediaQuery.lessThan('desktop')`
    width: 100%;
  `}
`;

export const FullNameError = styled.div`
  width: 100%;
`;

export const HorizontalDivider = styled(Divider)`
  &.MuiDivider-root {
    width: 100%;
  }
`;

export const ImageWithIcon = styled.div`
  position: relative;
  height: 72px;
  width: 72px;
  > div:last-of-type {
    position: absolute;
    right: 0%;
    bottom: 0%;
    border: 1px solid ${colorTokens.text.medium};
  }
`;

export const UploadImage = styled(Box)`
  &.MuiBox-root {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 0.25rem;
    p {
      text-align: center;
      width: 140px;
      font-size: 12px;
      color: ${colorTokens.text.medium};
    }
  }
`;

export const RiderContact = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: calc(50% - 18px);
  flex-shrink: 0;

  .MuiBox-root {
    display: flex;
    gap: 24px;
    align-items: center;

    label {
      width: 101px;
      min-width: 101px;
      flex-shrink: 0;
    }

    .MuiFormControl-root {
      flex: 1;
    }

    .MuiOutlinedInput-root {
      width: 100%;
    }

    .MuiFormHelperText-root {
      width: 100%;
    }
  }

  ${variables.mediaQuery.lessThan('desktop')`
    width: 100%;
    flex-shrink: 1;

    .MuiBox-root {
      flex-direction: column;
      align-items: flex-start;
      gap: 4px;

      label {
        width: auto;
        min-width: auto;
      }

      .MuiFormControl-root {
        width: 100%;
      }
    }
  `}
`;

export const ContactPhoto = styled(Box)`
  display: flex;
  align-items: center;
  gap: 2rem;
  width: 100%;

  ${variables.mediaQuery.lessThan('desktop')`
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  `}
`;
